import React, { useEffect } from 'react';
import { View } from '@/styles/reactnative';

const DerivativesNavBarTabs = React.memo(
  ({ tab, setTab, t, textsilver }: any) => {
    // console.log('렌더링됨')
    const tabs = ['L', 'M', 'CL'];

    return (
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'flex-start',
          padding: '0 16px',
          gap: 18,
          width: '100%',
          background: 'transparent',
        }}
      >
        {tabs?.map((item, index) => {
          let temp = tab;

          if (temp == 'CM') {
            temp = 'CL';
          } else {
            if (temp == 'CL') {
              temp = 'CL';
            }
          }

          return (
            <button
              key={`DerivativesNavBarTabs_${index}`}
              style={{
                color: item == temp ? '#fff' : '#777986',
                borderBottom:
                  item == temp ? '2px solid #07D993' : '2px solid transparent',
                padding: '10px 0',
                fontWeight: 600,
                fontSize: 14,
                lineHeight: '16.71px',
                fontFamily: 'NanumSquareRound',
              }}
              onClick={() => setTab(item)}
            >
              {t(
                item == 'L'
                  ? 'TradePage.Limit'
                  : item == 'M'
                    ? 'TradePage.Market'
                    : item == 'T' || item == 'CM' || item == 'CL'
                      ? 'TradePage.Trigger'
                      : ''
              )}
            </button>
          );
        })}
      </View>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.tab === nextProps.tab &&
      prevProps.textsilver === nextProps.textsilver &&
      prevProps.t === nextProps.t
    );
  }
);

export default DerivativesNavBarTabs;
